import { Message } from "element-ui";
import { alertError } from "./alert";
import axios from "axios";
import qs from "querystring";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";

// 创建实例
export function createInstance() {
  let baseURL = "";
  if (process.env.API_ENDPOINT) {
    baseURL = process.env.API_ENDPOINT;
  } else {
    // 本地
    baseURL = "/api";
  }
  return axios.create({
    baseURL,
    paramsSerializer: function (params) {
      return qs.stringify(params);
    },
    withCredentials: false,
  });
}
const service = createInstance();

// 请求拦截
service.interceptors.request.use(
  config => {
    const token = store.state.user.token;
    if (token) {
      const bearerToken = store.getters["user/getBearerToken"];
      config.headers["Authorization"] = bearerToken;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// 响应拦截
service.interceptors.response.use(
  response => {
    const { data, headers } = response;
    // 处理文件流
    if (headers["content-type"]?.includes("application/octet-stream")) {
      return response;
    }
    // 统一处理业务状态码
    if (data) {
      if (data.code && data.code !== 200) {
        alertError(data);
        return Promise.reject(data);
      } else {
        // 直接返回数据主体
        return data;
      }
    } else {
      return Promise.reject("error: Request to return no data");
    }
  },
  error => {
    const { response } = error;
    const i18nMessageError = i18n.messages[i18n.locale].common.error;
    if (response) {
      const { status, data } = response;
      switch (status) {
        case 401:
          // 退出登录(清空localstrong)
          store.dispatch("user/logout");
          // 登录失效，请重新登录
          Message.error(i18nMessageError.login);
          router.replace("/login");
          break;
        case 403:
          // 返回 403页面
          router.replace("/403");
          break;
        case 500:
          // 服务错误
          Message.error(i18nMessageError.server);
          break;
        default:
          // 其他错误
          Message.error(i18nMessageError.request);
      }
    } else {
      if (error.message.includes("timeout")) {
        // 超时
        Message.error(i18nMessageError.timeout);
      } else {
        // 无法连接到服务器
        Message.error(i18nMessageError.disconnect);
      }
    }
    return Promise.reject(error);
  },
);

export default service;
